import React from 'react';

function HeadToHead() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-6">
      <div className="mb-12 relative">
        <div className="absolute -top-10 -left-10 w-32 h-32 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-25 animate-blob"></div>
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-emerald-500 rounded-full mix-blend-multiply filter blur-xl opacity-25 animate-blob animation-delay-2000"></div>
      </div>

      <div className="flex items-center justify-center h-[70vh]">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-blue-500">
            Head to Head Analysis
          </h1>
          <p className="text-gray-400 text-lg">
            Coming Soon
          </p>
          <p className="text-sm text-gray-500">
            Deep statistical analysis and performance comparisons between teams
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeadToHead;